<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useRoute } from 'vue-router';

import Dialog from 'next/dialog/Dialog.vue';

const { t } = useI18n();
const store = useStore();
const route = useRoute();

const dialogRef = ref(null);

const botId = computed(() => Number(route.params.botId));

const handleConfirm = async () => {
  try {
    await store.dispatch('wgptBotKnowledgeManager/reset', botId.value);
    dialogRef.value?.close();
  } catch (error) {
    useAlert(error.message);
  }
};

const open = () => {
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="
      t('WGPT_BOTS.EDIT.TABS.KNOWLEDGE_MANAGER.RESET_SESSION_DIALOG.TITLE')
    "
    :description="
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_MANAGER.RESET_SESSION_DIALOG.DESCRIPTION'
      )
    "
    :confirm-button-label="
      t('WGPT_BOTS.EDIT.TABS.KNOWLEDGE_MANAGER.RESET_SESSION_DIALOG.CONFIRM')
    "
    :cancel-button-label="
      t('WGPT_BOTS.EDIT.TABS.KNOWLEDGE_MANAGER.RESET_SESSION_DIALOG.CANCEL')
    "
    @confirm="handleConfirm"
  />
</template>
